import styled, {css} from 'styled-components'

/**
 * The wide bar's reserved row.
 *
 * It is deliberately **in normal flow** — it occupies its own grid row above `<Outlet />` so it
 * reserves its own height and hides nothing (FR-018/FR-022) — while still carrying
 * `position: relative` and the `contextBar` layer so it paints above every overlay (FR-022a).
 * That works because a positioned in-flow element competes in the root stacking context with the
 * fixed overlays and wins on the higher value.
 *
 * This relies on no ancestor creating a stacking context: `StyledPrivateLayout` and its content
 * wrapper are plain grid divs with no transform/filter/opacity/will-change. Introducing one there
 * would silently trap the bar below dialogs.
 *
 * With no work context the element is empty and collapses to zero height, so the row costs nothing.
 */
export const StyledNotificationContextBarRow = styled.div(
    ({theme: {zIndex}}) => css`
        position: relative;
        z-index: ${zIndex.contextBar};
    `
)
